import { getItems } from 'common/api/panelsBrands';

import {
    FETCH_BRANDS_ITEMS,
    FETCH_BRANDS_ITEMS_FAILURE,
    FETCH_BRANDS_ITEMS_SUCCESS,
} from '../actionTypes';
import { actions } from '../reducer';

export default () => (dispatch) => {
    dispatch(actions[FETCH_BRANDS_ITEMS]());

    getItems()
        .then((response) =>
            dispatch(actions[FETCH_BRANDS_ITEMS_SUCCESS](response.data.data)),
        )
        .catch((error) =>
            dispatch(
                actions[FETCH_BRANDS_ITEMS_FAILURE](
                    error?.response?.data?.errors,
                ),
            ),
        );
};
